export default {
  pageTitle: 'Produk',
  metaDescription: 'Jelajahi produk fabrikasi TEF: pressure vessel, heat exchanger, piping, tower, muffle, radiant tube, dan peralatan industri lainnya dengan material khusus.',
  fabricationOf: 'Fabrikasi',
  categories: {
    vessel: 'Vessel',
    heatExchanger: 'Heat Exchanger',
    piping: 'Piping',
    tower: 'Tower',
    radiantTube: 'Radiant Tube',
    muffle: 'Muffle',
    otherEquipment: 'Other Equipment',
  },
  onSiteServices: {
    heading: 'LAYANAN ON-SITE',
    items: {
      weldingOverlay: 'Welding Overlay',
      patching: 'Patching',
      piping: 'Piping',
      reShell: 'Re-Shell',
      reTubing: 'Re-Tubing',
      shutdownMaintenance: 'Pemeliharaan Shutdown',
    },
  },
};
